import { motion } from "framer-motion";
import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp } from "lucide-react";

const HINTS = [
  { dir: "up", icon: ArrowUp, title: "Seen it · Liked it", pos: "top-5 left-1/2 -translate-x-1/2 flex-col", anim: { y: [0, -8, 0] } },
  { dir: "down", icon: ArrowDown, title: "Seen it · Didn't like", pos: "bottom-5 left-1/2 -translate-x-1/2 flex-col-reverse", anim: { y: [0, 8, 0] } },
  { dir: "left", icon: ArrowLeft, title: "Not interested", pos: "left-4 top-[30%] -translate-y-1/2 flex-col", anim: { x: [0, -8, 0] } },
  { dir: "right", icon: ArrowRight, title: "Want to watch", pos: "right-4 top-[30%] -translate-y-1/2 flex-col", anim: { x: [0, 8, 0] } },
];

export const SwipeTutorial = ({ onDismiss }) => (
  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="swipe-tutorial"
    className="absolute inset-0 z-[45] rounded-3xl bg-black/75 backdrop-blur-[3px] text-white">
    {HINTS.map(({ dir, icon: Icon, title, pos, anim }) => (
      <div key={dir} className={`absolute flex items-center gap-1.5 text-center ${dir === "up" || dir === "down" ? "w-40" : "w-24"} ${pos}`} data-testid={`swipe-tutorial-${dir}`}>
        <motion.span animate={anim} transition={{ repeat: Infinity, duration: 1.4 }}
          className="h-11 w-11 rounded-full border-2 flex items-center justify-center"
          style={{ borderColor: `hsl(var(--sp-${dir}))`, color: `hsl(var(--sp-${dir}))` }}>
          <Icon className="h-5 w-5" strokeWidth={3} />
        </motion.span>
        <span className="text-xs font-bold leading-tight">{title}</span>
      </div>
    ))}
    <div className="absolute inset-x-0 top-[47%] flex flex-col items-center gap-3 px-8 text-center pointer-events-none">
      <p className="font-display text-xl font-black leading-tight">Swipe the card in any direction</p>
      <p className="text-xs text-white/70">Or use the buttons below. Tap a card for cast & trailer.</p>
      <button onClick={onDismiss} data-testid="swipe-tutorial-dismiss"
        className="pointer-events-auto h-11 px-6 rounded-full bg-primary font-bold text-sm transition-transform hover:scale-105 active:scale-95">
        Got it
      </button>
    </div>
  </motion.div>
);
